<template>
  <div>
    <v-card>
      <v-toolbar
        dense
        flat
        dark
        color="primary"
      >
        <v-icon
          left
        >
          mdi-file-sign
        </v-icon>&nbsp;&nbsp;
        Form Signatures
        <v-spacer />
        <v-btn
          flat
          @click="pollEsign()"
        >
          Poll E-signature Provider
        </v-btn>
        <v-btn
          flat
          fab
          dark
          @click="fetch()"
        >
          <v-icon
            v-bind:class="{ spin: loading }"
          >
            refresh
          </v-icon>
        </v-btn>
        <v-btn
          flat
          fab
          dark
          @click="$emit('close')"
        >
          <v-icon>
            close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-progress-linear
        v-if="loading"
        active
        indeterminate
        query
        style="margin:0;"
      />
      <v-layout
        row
        wrap
      >
        <v-flex
          sm4
          style="background: rgb(247,247,247);border-right:1px solid rgba(26,26,26,0.3);"
        >
          <div
            v-if="checkPermission('userform', PERMISSIONS.CAN_EDIT)"
            style="text-align:center;"
            class="upload_div"
          >
            <v-btn
              small
              color="primary"
              dark
              flat
              @click="fileUploadDialog()"
            >
              <v-icon
                left
                small
              >
                mdi-upload
              </v-icon>
              Upload Signature
            </v-btn>
            <input
              type="file"
              ref="fileInput"
              style="display:none"
              accept="application/pdf"
              v-on:change="handleFileUpload()"
            />
          </div>
          <div
            style="height: 600px;overflow-y:auto;"
          >
            <div
              v-for="s in filteredSignatures"
              :key="s.id"
              class="sign_event"
              :class="{ focused: isFocused(s), valid: !s.void }"
              style="padding:10px;"
              @click="focusEsign = s"
            >
              <div>
                <span
                  v-if="s.esign"
                >
                  <b>E-signature Request</b>
                </span>
                <span
                  v-else
                >
                  <b>File Upload</b>
                </span>
                <span
                  style="float: right"
                >
                  {{convertToCalRef(s.sent_at)}}
                </span>
              </div>
              <div>
                by {{s.sent_by_name}}
              </div>
              <br />
              <div>
                <span
                  style="text-transform: capitalize;"
                >
                  {{s.status}}
                </span>
                <span
                  style="float: right;text-transform: uppercase;color:rgba(0,0,0,0.7)"
                >
                  <span
                    v-if="!s.void"
                  >
                    <v-chip label dark small color="success">Current</v-chip>
                  </span>
                  <v-icon
                    small
                  >
                    {{getStatusIcon(s)}}
                  </v-icon>
                </span>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex
          sm8
          v-if="focusEsign"
        >
          <v-card>
            <v-card-text>
              <div
                v-if="focusEsign"
              >
                <b
                  v-if="!focusEsign.void"
                >
                  Current Signature
                </b><br />
                <b>Envelope ID: </b>{{focusEsign.envelope_id}}<br />
                <b>Sent at </b>{{convertToLocal(focusEsign.sent_at)}} by <u>{{focusEsign.sent_by_name}}</u><br />
                <b>Last Updated at </b>{{convertToLocal(focusEsign.updated_at)}}<br />
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                flat
                small
              >
                Status:
                <v-chip
                  small
                  label
                  dark
                  :color="getStatusColor(focusEsign)"
                >
                  {{focusEsign.status}}
                </v-chip>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="focusEsign.status.toLowerCase() == 'completed' && focusEsign.void"
                small
                flat
                style="margin:0;"
                @click="openCurrentDialog()"
              >
                Set Current
              </v-btn>
              <v-btn
                v-if="focusEsign.original_file"
                small
                flat
                style="margin:0;"
                @click="downloadEvent(focusEsign.envelope_id, true)"
              >
                Download Unsigned
              </v-btn>
              &nbsp;&nbsp;
              <v-btn
                v-if="focusEsign.signed_file"
                small
                color="primary"
                dark
                style="margin:0;"
                @click="downloadEvent(focusEsign.envelope_id)"
              >
                Download
              </v-btn>
            </v-card-actions>
          </v-card>
          <div
            style="height:475px;"
          >
            <iframe
              v-if="pdfPreview"
              :src="`data:application/pdf;base64,${pdfPreview}`"
              style="width: 100%;height:100%;"
            />
            <div
              v-else-if="loadingPreview"
              style="width: 100%;height:100%;background:rgba(0,0,0,0.1);padding:150px;text-align:center;font-size:16px;"
            >
              <v-icon
                size="64"
              >
                mdi-file-sync
              </v-icon><br /><br />
              Loading Preview...
            </div>
            <div
              v-else-if="focusEsign.status.toLowerCase() == 'declined'"
              style="width: 100%;height:100%;background:rgba(0,0,0,0.1);padding:150px;text-align:center;font-size:16px;"
            >
              <v-icon
                size="64"
                color="error"
              >
                mdi-cancel
              </v-icon><br /><br />
              A signer declined to sign this form.<br /><br />
              <div
                v-if="focusEsign.message"
                style="border: 1px solid #262626;background:#fefefe;padding:5px;"
              >
                <b>Reason:</b><br />
                {{focusEsign.message}}
              </div>
            </div>
            <div
              v-else-if="focusEsign.status.toLowerCase() == 'voided'"
              style="width: 100%;height:100%;background:rgba(0,0,0,0.1);padding:150px;text-align:center;font-size:16px;"
            >
              <v-icon
                size="64"
                color="error"
              >
                mdi-file-cancel
              </v-icon><br /><br />
              This envelope was voided.<br />
              <small>
                This may be due to a request timeout, or the document may have been updated.
              </small>
            </div>
            <div
              v-else
              style="width: 100%;height:100%;background:rgba(0,0,0,0.1);padding:150px;text-align:center;font-size:16px;"
            >
              <v-icon
                size="64"
              >
                mdi-file-outline
              </v-icon><br /><br />
              No Preview Available
            </div>
          </div>
        </v-flex>
        <v-flex
          sm8
          v-else
        >
          <div
            style="padding: 150px;font-size: 16px;text-align:center;"
          >
            This form has no valid signature.
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-snackbar
      v-model="showSnack"
      :timeout="6000"
      multi-line
    >
      {{snackMessage}}
    </v-snackbar>
    <v-dialog
      v-model="statusChangeDialog"
      persistent
      width="600"
    >
      <v-card>
        <v-card-text>
          <b>Form must be Complete to make changes to signing events.</b><br />
          Please change the status to "Complete" in order to modify or upload signing events. The form data must be locked in order to sign.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="statusChangeDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDialog"
      persistent
      width="600"
    >
      <v-card>
        <v-card-text>
          <iframe
            v-if="uploadPreview"
            :src="uploadPreview"
            style="width: 100%;min-height:450px;"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            flat
            :disabled="uploading"
            @click="confirmDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            :disabled="uploading"
            @click="doFileUpload()"
          >
            Upload Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="currentDialog"
      persistent
      width="600"
    >
      <v-card>
        <v-card-text>
          <div
            v-if="focusEsign"
          >
            <b>Setting this signature to the current signature will not revert or update answers.</b><br /><br />
            This signed form will represent the answers present in the form when it was signed {{convertToCalRef(focusEsign.sent_at)}}. If any answers in the form have been updated since then, this signature will not be up to date.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            flat
            @click="currentDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            dark
            @click="setEsignActive(focusEsign)"
          >
            Set Current
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'UserFormSignatures',
  props: [ 'userform' ],
  data () {
    return {
      signatures: null,
      loading: false,
      showSnack: false,
      snackMessage: null,
      focusEsign: null,
      loadingPreview: false,
      pdfPreview: null,
      currentDialog: false,
      confirmDialog: false,
      statusChangeDialog: false,
      uploadPreview: null,
      uploading: false,
      headers: [
        {
          text: 'Signature',
          width: 250
        },
        {
          text: 'Sent/Created'
        },
        {
          text: 'Last Update'
        },
        {
          text: 'Download'
        }
      ],
    }
  },
  computed: {
    validSig () {
      if (this.signatures && this.signatures.length > 0)
        return this.signatures.filter((e) => !e.void)[0]
      return null
    },
    filteredSignatures () {
      return this.signatures ? this.signatures.reverse() : []
    }
  },
  created () {
    this.fetch()
  },
  watch: {
    userform () {
      this.fetch()
    },
    focusEsign () {
      if (!this.focusEsign)
        return
      this.pdfPreview = null
      this.loadingPreview = true
      if (this.focusEsign.status.toLowerCase() !== 'completed') {
        this.loadingPreview = false
        return
      }
      api.userform.userForm.downloadEsign(this.userform.id, this.focusEsign.envelope_id)
        .then(response => {
          var base64 = btoa(
            new Uint8Array(response.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          this.pdfPreview = base64
          this.loadingPreview = false
        })
        .catch((e) => {
          this.loadingPreview = false
        })
    }
  },
  methods: {
    fetch () {
      this.signatures = null
      this.loading = true
      api.userform.userForm.getEsigns(this.userform.id)
        .then(results => {
          this.signatures = results
          this.focusEsign = this.signatures.filter((e) => !e.void)[0]
          this.loading = false
        })
    },
    isFocused (e) {
      return e === this.focusEsign
    },
    getStatusIcon(s) {
      if (['declined', 'voided'].includes(s.status.toLowerCase()))
        return 'mdi-file-cancel'
      if (s.status.toLowerCase() == 'sent')
        return 'mdi-email-fast'
      if (s.status.toLowerCase() == 'delivered')
        return 'mdi-eye'
      if (s.status.toLowerCase() == 'completed')
        return 'mdi-check'
    },
    getStatusColor(s) {
      if (['declined', 'voided'].includes(s.status.toLowerCase()))
        return 'error'
      if (s.status.toLowerCase() == 'sent')
        return ''
      if (s.status.toLowerCase() == 'delivered')
        return 'primary'
      if (s.status.toLowerCase() == 'completed')
        return 'success'
    },
    downloadEvent (envelopeId, original=null) {
      this.$emit('download', true)
      api.userform.userForm.downloadEsign(this.userform.id, envelopeId, original)
      .then(response => {
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = envelopeId + (original ? ' - Original' : ' - Signed') + '.pdf'
        link.click()
        this.$emit('download', false)
      })
    },
    pollEsign () {
      api.userform.userForm.pollEsign(this.userform.id)
        .then(response => {
          this.signatures = response
          this.$emit('refetch')
        })
        .catch(error => {
          this.snackMessage = error.response.data
          this.showSnack = true
        })
    },
    setEsignActive (s) {
      this.currentDialog = false
      api.userform.userForm.updateEsign(this.userform.id, s.envelope_id)
        .then(() => {
          this.fetch()
        })
    },
    openCurrentDialog() {
      if (this.userform.status == "complete") {
        this.currentDialog = true
      } else {
        this.statusChangeDialog = true
      }
    },
    fileUploadDialog() {
      if (this.userform.status == "complete") {
        this.$refs.fileInput.click()
      } else {
        this.statusChangeDialog = true
      }
    },
    handleFileUpload () {
      var files = this.$refs.fileInput.files
      if (files.length > 0) {
        var reader = new FileReader()
        reader.onload = (res) => {
          this.uploadPreview = res.target.result
        }
        reader.onerror = (err) => console.log(err)
        reader.readAsDataURL(files[0])
        this.confirmDialog = true
      }
    },
    doFileUpload() {
      var files = this.$refs.fileInput.files
      const data = new FormData()
      if (files.length > 0) {
        this.uploading = true
        data.append(`signed_file`, files[0])
        api.userform.userForm.uploadEsign(this.userform.id, data)
          .then(() => {
            this.uploading = false
            this.confirmDialog = false
            this.$emit('refetch')
            this.fetch()
          })
      }
    }
  }
}
</script>

<style scoped>

.upload_div {
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.sign_event {
  border-bottom: 1px solid rgba(0,0,0,0.05);
  transition: 0.3s;
  cursor: pointer;
}

.focused {
  background: rgba(26,26,26,0.1);
}

.sign_event:hover {
  background: rgba(26,26,26,0.2);
}

.spin {
    -webkit-animation: spin 1000ms infinite linear;
    animation: spin 1000ms infinite linear;
}
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

.voided {
  opacity: 0.5;
}

</style>
